// extracted by mini-css-extract-plugin
export var active = "_2m-2";
export var highlight = "_2m-1";
export var highlightLayer = "_2m-0";
export var issuePopover = "_2m-3";
export var statusIcon = "_2m-4";